export const DEFAULT_LANGUAGE = 'fr';
export const DEFAULT_COUNTRY = 'FR';
export const DEFAULT_DATE_FORMAT = 'DD/MM/YYYY';
export const DATE_FORMAT_ARRAY = ['DD/MM/YYYY', 'DD/MM/YY', 'DD-MM-YYYY', 'DD-MM-YY'];
export const DEFAULT_DATE_FORMAT_WITH_TIME = 'DD/MM/YYYY HH:mm';
export const DEFAULT_COUNTRY_LANGUAGE_SEPARATOR = '_';

export const LOCAL_STORAGE_KEYS = {
  Auth: 'Authentication',
  IsLoggedIn: 'IsLoggedIn',
  Language: 'LANGUAGE',
  Mode: 'MODE',
  SatcMode: 'SATC_MODE',
  SatcVisible: 'SATC_VISIBLE',
  CurrentCountry: 'CURRENTCOUNTRY',
  AppToken: 'APP_TOKEN',
  UserToken: 'USER_TOKEN',
  RefreshToken: 'REFRESH_TOKEN',
  SessionCode: 'SESSION_CODE',
  LogoutUrl: 'LOGOUT_URL',
  LoginState: 'LOGIN_STATE',
  Country: 'COUNTRY',
};

export const SESSION_STORAGE_KEYS = {
  PreviousURL: 'PREVIOUS_URL',
  ArticleAddToCard: 'ARTICLE_ADD_TO_CARD',
  ArticleReplace: 'ARTICLE_REPLACE',
  RetryStatus: 'RETRY_STATUS',
  RetryUrl: 'RETRY_URL',
  RetryCounter: 'RETRY_COUNTER',
  RetryMessage: 'RETRY_MESSAGE',
  ShowWarrantyRequest: 'SHOW_WARRANTY_REQUEST',
  WarrantyRequestLoaded: 'WARRANTY_REQUEST_LOADED',
};

export enum SLUG_ACCESS_KEYS {
  Commande = 'commande',
  Sav = 'sav',
  SeeDiscountedPrice = 'voir-les-prix-remisés',
  BankCardPayment = 'paiement-cb',
  GestionCollaborateurs = 'gestion-collaborateurs',
  StationWeb = 'station-web',
}

export const APP_URL = {
  Base: '/:lang',
  HomePage: '',
  Template: 'template',
  ShoppingCart: 'panier',
  ShoppingCartSuccess: 'panier/:result_status',
  WarrantyHistory: 'garantie/historique',
  WarrantyReplacement: 'garantie/demandes/:reference?', // modify this route if something
  WarrantyRequestShow: 'garantie_demande',
  OrderHistory: 'commandes/historique',
  OrderDetails: 'commandes/:id',
  QuoteHistory: 'devis/historique',
  Profile: 'profil',
  Societe: 'societe',
  Clients: 'clients',
  Login: 'login',
  Logout: 'logout',
  WsoCallback: 'wso/callback',
  WebStatonRedirect: 'redirect/webstation',
  ConnectAs: 'connectas/:code',
  RedirectResource: 'go',
  Search: 'recherche/:keywords?',
  Family: 'familles/:id',
  FamilyDetail: 'familles/:id/detail/:tabname',
  Product: 'produits/:id',
  ProductSchema: 'produits/:id/schema_uuid/:schema_uuid',
  ProductReseau: 'produits/:id/reseaux/:reseau_uuid',
  Article: 'articles/:id',
  ArticleReseau: 'articles/:id/reseaux/:reseau_uuid',
  //Article: 'articles/:id',
};

export const UNIVERS = {
  AtlanticFR: 'atlantic-fr',
  Atlantic: 'atlantic',
  Pacific: 'pacific',
  Thermor: 'thermor',
  ThermorFR: 'thermor-fr',
  Acv: 'acv',
  AcvFR: 'acv-fr',
  AutresMarques: 'autres-marques',
  EquationWelcome: 'equation-welcome',
  Oem: 'oem',
  Sauter: 'sauter',
  Ygnis: 'ygnis',
  Orcon: 'orcon',
  EspaceSav: 'espace-sav',
  Other: 'other'
};

export const OTHER_WEBSITES = { StationWeb: 'station-web' };

export const OrderStatus = {
  Creee: 'creee',
  Attente: 'attente',
  AttenteSATC: 'attente-satc',
  AttenteBanque: 'attente-banque',
  AttentePaiement: 'attente-paiement',
  Soldee: 'soldee',
  Expediee: 'expediee',
  Validee: 'validee',
  RefuseePrestatairePaiement: 'refusee-prestataire-paiement',
  Annulee: 'annulee',
};

export const WarrantyType = {
  Commande: 'commande',
  Retour: 'retour',
};

export const WarrantyRequestSteps = {
  etape1: 'etape_1',
  etape2: 'etape_2',
  etape3: 'etape_3',
  etape_end: 'etape_end',
};

export const WarrantyRequestSatcStatus = {
  PasDemande: 'non-demandee',
  Attente: 'en-cours',
  Valide: 'acceptee',
  Refuse: 'refusee',
};

export const WarrantyRequestValideStatus = {
  EnCours: 'en-cours',
  Valide: 'validee',
  Exporte: 'expediee',
  Transmise: 'transmise',
  Acceptee: 'acceptee',
  Refusee: 'refusee',
  Partiel: 'partielle',
  NonRecevable: 'non-recevable',
};

export const WarrantyItemTypes = {
  Product: 'garantie_produit',
  Article: 'garantie_piece',
};

export const WarrantyStage2FormFields = {
  date_mise_en_service: 'date_mise_en_service',
  defaut_uuid: 'defaut_uuid',
  no_serie: 'no_serie',
  commentaire: 'commentaire',
  dossier: 'dossier',
  renvoie_produit: 'renvoie_produit',
  renvoie_piece: 'renvoie_piece',
};

export const WarrantyStage2FormFieldsByType = {
  [WarrantyItemTypes.Product]: [
    WarrantyStage2FormFields.date_mise_en_service,
    WarrantyStage2FormFields.defaut_uuid,
    WarrantyStage2FormFields.no_serie,
    WarrantyStage2FormFields.commentaire,
  ],
  [WarrantyItemTypes.Article]: [
    WarrantyStage2FormFields.dossier,
    WarrantyStage2FormFields.defaut_uuid,
  ],
};

export const WarrantyDeliveryFormFields = {
  reference_commande: 'reference_commande',
  livraison_raison_sociale: 'livraison_raison_sociale',
  livraison_nom: 'livraison_nom',
  livraison_adresse1: 'livraison_adresse1',
  livraison_adresse2: 'livraison_adresse2',
  livraison_code_postal: 'livraison_code_postal',
  livraison_ville: 'livraison_ville',
  email: 'email',
  is_info_tracking: 'is_info_tracking',
  livraison_pays: 'livraison_pays',
  ligne_adressage_factu: 'ligne_adressage_factu',
};

export const WarrantyInstallerFormFields = {
  client_uuid: 'client_uuid',
  no_bon_retour_client: 'no_bon_retour_client',
};

export type HelpItemModel = {
  type: string;
  id?: number;
  file?: any;
};
export type HelpModel = Record<string, Record<string, HelpItemModel>>;

export const helpItems: HelpModel = {
  atlantic: {
    video_commandepiece: {
      type: 'vimeo',
      id: 343451354,
    },
    video_demandegarantie: {
      type: 'vimeo',
      id: 343451375,
    },
    video_informationstechniques: {
      type: 'vimeo',
      id: 343451333,
    },
    trouverProduitConcerne: {
      //+
      type: 'link',
      file: 'https://stpfsprd5601.blob.core.windows.net/images-thumbs/help/atlantic/Trouver_le_produit_concern%C3%A9.pdf',
    },
    accederInfoTechniques: {
      //+
      type: 'link',
      file: 'https://stpfsprd5601.blob.core.windows.net/images-thumbs/help/atlantic/Acc%C3%A9der_%C3%A0_la_documentation_technique.pdf', 
    },
    commanderPieceDetachee: {
      //+
      type: 'link',
      file: 'https://stpfsprd5601.blob.core.windows.net/images-thumbs/help/atlantic/Commander_une_pi%C3%A8ce_de_rechange.pdf',
    },
    faireDemandeGarantie: {
      //+
      type: 'link',
      file: 'https://stpfsprd5601.blob.core.windows.net/images-thumbs/help/atlantic/Faire_une_demande_de_garantie.pdf',
    },
    creerAccesCollab: {
      //+
      type: 'link',
      file: 'https://stpfsprd5601.blob.core.windows.net/images-thumbs/help/atlantic/Cr%C3%A9er_un_acc%C3%A8s_collaborateur.pdf',
    },
    obtenirUnDevis: {
      //+
      type: 'link',
      file: 'https://stpfsprd5601.blob.core.windows.net/images-thumbs/help/atlantic/Obtenir_un_devis.pdf',
    },
    RechercheParNumeroDeSerie: {
      //+
      type: 'link',
      file: 'https://stpfsprd5601.blob.core.windows.net/images-thumbs/help/atlantic/Recherche_par_num%C3%A9ro_de_s%C3%A9rie.pdf',
    },
  },
  'espace-sav': {
    video_commandepiece: {
      type: 'vimeo',
      id: 450134848,
    },
    trouverProduitConcerne: {
      //+
      type: 'link',
      file: 'https://stpfsprd5601.blob.core.windows.net/images-thumbs/help/thermor/Trouver_le_produit_concern%C3%A9.pdf',
    },
    commanderPieceDetachee: {
      //+
      type: 'link',
      file: 'https://stpfsprd5601.blob.core.windows.net/images-thumbs/help/thermor/Commander_une_pi%C3%A8ce_de_rechange.pdf', 
    },
    faireDemandeGarantie: {
      //+
      type: 'link',
      file: 'https://stpfsprd5601.blob.core.windows.net/images-thumbs/help/thermor/Faire_une_demande_de_garantie.pdf',
    },
    creerAccesCollab: {
      //+
      type: 'link',
      file: 'https://stpfsprd5601.blob.core.windows.net/images-thumbs/help/thermor/Cr%C3%A9er_un_acc%C3%A8s_collaborateur.pdf',
    },
  },
  thermor: {
    video_commandepiece: {
      type: 'vimeo',
      id: 450134848,
    },
    trouverProduitConcerne: {
      //+
      type: 'link',
      file: 'https://stpfsprd5601.blob.core.windows.net/images-thumbs/help/thermor/Trouver_le_produit_concern%C3%A9.pdf',
    },
    commanderPieceDetachee: {
      //+
      type: 'link',
      file: 'https://stpfsprd5601.blob.core.windows.net/images-thumbs/help/thermor/Commander_une_pi%C3%A8ce_de_rechange.pdf',
    },
    creerAccesCollab: {
      //+
      type: 'link',
      file: 'https://stpfsprd5601.blob.core.windows.net/images-thumbs/help/thermor/Cr%C3%A9er_un_acc%C3%A8s_collaborateur.pdf',
    },
  },
  sauter: {
    video_commandepiece: {
      type: 'vimeo',
      id: 450142701,
    },
    trouverProduitConcerne: {
      //+
      type: 'link',
      file: 'https://stpfsprd5601.blob.core.windows.net/images-thumbs/help/sauter/trouver_le_produit_concerne.pdf',
    },
    accederInfoTechniques: {
      //+
      type: 'link',
      file: 'https://stpfsprd5601.blob.core.windows.net/images-thumbs/help/sauter/acceder_aux_informations_techniques.pdf',
    },
    commanderPieceDetachee: {
      //+
      type: 'link',
      file: 'https://stpfsprd5601.blob.core.windows.net/images-thumbs/help/sauter/commander_une_piece_detach%C3%A9e.pdf',
    },
    creerAccesCollab: {
      //+
      type: 'link',
      file: 'https://stpfsprd5601.blob.core.windows.net/images-thumbs/help/sauter/creer_un_acces_collaborateur.pdf',
    },
  },
};